export const Heading_Section_Built_For_The_Best = {
  heading: "BUILT FOR THE BEST"
}

export interface IBuiltForTheBestStatItem {
  labelLines: string[];
  suffix: string;
  value: string;
}

export const Stats_Section_Built_For_The_Best: IBuiltForTheBestStatItem[] = [
  {
    value: "100",
    suffix: "k+",
    labelLines: ["USERS USING APP BUILT BY US"],
  },
  {
    value: "4.5",
    suffix: "★",
    labelLines: ["AVG MOBILE APP RATINGS"],
  },
  {
    value: "99",
    suffix: "%",
    labelLines: ["PROJECT SUCCESS RATE"],
  },
];
